import React from 'react';
import RichTextBlock from './RichTextBlock';

/**
 * BlockRenderer - Routes blocks to their respective renderers
 * Supports block-based event content system
 */
const BlockRenderer = ({ blocks, language = 'th' }) => {
  if (!blocks || !Array.isArray(blocks) || blocks.length === 0) {
    return null;
  }

  // Sort blocks by order
  const sortedBlocks = [...blocks].sort((a, b) => (a.order || 0) - (b.order || 0));

  return (
    <>
      {sortedBlocks.map((block) => {
        switch (block.type) {
          case 'rich_text':
            return (
              <RichTextBlock
                key={block.id || `block-${block.order}`}
                block={block}
                language={language}
              />
            );
          
          // Other block types will be added in future steps
          case 'hero':
          case 'raid_boss':
          case 'wild_encounter':
          case 'egg_hatch':
          case 'bonus':
            // Placeholder - will be implemented in future steps
            return null;
          
          default:
            // Unknown block type - skip silently
            console.warn(`Unknown block type: ${block.type}`);
            return null;
        }
      })}
    </>
  );
};

export default BlockRenderer;
